import React from "react";
import './App.css';
import Index from "./route/Index";

function App() {
  return (
    <>
    <Index />
    </>

  );
}

export default App;
